import { QRCodeSVG } from "qrcode.react";
import { StatusPill } from "@/components/PageHeader";
import { cedi2 as cedi, fmtDate } from "@/lib/api";

export const statusOf = (r) => (r.voided ? "Voided" : r.status);

const Line = ({ label, children, testId }) => (
  <><span className="text-gray-500">{label}</span><span data-testid={testId}>{children}</span></>
);

export const SpecialReceiptView = ({ r }) => (
  <div className="print-area special-print bg-white text-[#111] relative" data-testid="special-receipt-document">
    {r.voided && <div className="absolute inset-0 grid place-items-center pointer-events-none"><span className="rotate-[-18deg] border-4 border-red-600 text-red-600 font-heading font-extrabold text-5xl px-6 py-2 opacity-30">VOID</span></div>}
    <div className="flex items-center gap-3 border-b-4 border-[#E60000] pb-4">
      <img src="/images/gamls-logo.png" alt="GAMLS" className="w-14 h-14" />
      <div><div className="font-heading font-extrabold">Ghana Association of Medical Laboratory Scientists</div><div className="text-xs text-gray-500">Receipt</div></div>
    </div>
    <div className="grid grid-cols-2 gap-y-2 text-sm mt-4">
      <Line label="Receipt No."><span className="font-mono font-semibold" data-testid="special-receipt-no">{r.receipt_no}</span></Line>
      <Line label="Received from">{r.payer_name}</Line>
      {r.pin && <Line label="AHPC PIN"><span className="font-mono">{r.pin}</span></Line>}
      {r.phone && <Line label="Phone">{r.phone}</Line>}
      {r.email && <Line label="Email"><span className="break-all">{r.email}</span></Line>}
      <Line label="Being payment for" testId="special-receipt-description">{r.description}</Line>
      {r.event_title && <Line label="Event">{r.event_title}</Line>}
      <Line label="Method">{r.method}</Line>
      {r.cheque_no && <Line label="Cheque No."><span className="font-mono" data-testid="special-receipt-cheque-no">{r.cheque_no}</span></Line>}
      {r.cheque_bank && <Line label="Bank">{r.cheque_bank}</Line>}
      {r.cheque_issuer && <Line label="Issuer">{r.cheque_issuer}</Line>}
      <Line label="Date">{fmtDate(r.paid_at || r.created_at)}</Line>
      <Line label="Status"><StatusPill status={statusOf(r)} /></Line>
      {r.recorded_by && <Line label="Received by">{r.recorded_by}</Line>}
      {r.voided && <Line label="Void reason" testId="special-receipt-void-reason">{r.void_reason}</Line>}
    </div>
    <div className="flex items-end justify-between mt-6 pt-4 border-t">
      <div><div className="text-xs text-gray-500">Amount</div><div className="font-heading text-3xl font-extrabold" data-testid="special-receipt-amount">{cedi(r.amount)}</div></div>
      <QRCodeSVG value={`${r.receipt_no}|${r.amount}`} size={72} />
    </div>
    <div className="mt-5 bg-[#E60000] text-white text-center text-xs font-bold tracking-[0.2em] py-2">SERVICE TO HUMANITY</div>
  </div>
);
